/**
 * Who is taking part in the Gathering: a guest who joined with the passcode
 * (utils/guest_session.js), else the signed-in Keycloak user. The one seam
 * that lets the member view and the call stay the same for both — they only
 * ever need a user_id and a display name.
 *
 *   const { userId, name, isGuest, leave } = useGatheringIdentity();
 *
 * `leave()` forgets a guest identity (no-op for members); the guest can
 * join again from /gathering/join while the passcode still works.
 */

import { useMemo, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { readGuest, clearGuest } from '../utils/guest_session';

export function useGatheringIdentity() {
    const { user } = useAuth();
    // Read on every render: cheap, and it notices a pass expiring.
    const guest = readGuest();
    const guestId = guest?.user_id;
    const guestName = guest?.name;

    const identity = useMemo(() => (guestId
        ? { userId: guestId, name: guestName, isGuest: true }
        : { userId: user?.id, name: user?.username || user?.email || user?.id, isGuest: false }),
    [guestId, guestName, user]);

    const leave = useCallback(() => clearGuest(), []);

    return { ...identity, leave };
}

export default useGatheringIdentity;
